// extracted by mini-css-extract-plugin
module.exports = {"list":"BinaryWrapper__list___1jwD9","link-wrapper":"BinaryWrapper__link-wrapper___1ctC6","link-arrow":"BinaryWrapper__link-arrow___2wMB5"};